import { getOrganisationId } from '@/kernel/session';
import { getCollection } from '@/kernel/collections';

export const DateRangeFilterAdapter = (key, value) => {
  const fragment = {and: []}
  
  if (value.from) {
    fragment.and.push({[key]: {greater_than_equal: value.from}});
  }
  
  if (value.to) {
    fragment.and.push({[key]: {less_than_equal: value.to}});
  }
  
  return fragment;
}

export const SelectFilterAdapter = (key, value) => {
  return {
    and: [
      {
        [key]: {
          equals: value
        }
      }
    ]
  }
}

export const DefaultFilterAdapter = (key, value) => {
  return {
    and: [
      {
        [key]: {
          equals: value
        }
      }
    ]
  }
}

export const SingleRelationFilterAdapter = (collection) => {
  collection = getCollection(collection);
  
  return (key, value) => {
    return {
      and: [
        {
          [key]: {
            equals: collection.getId(value)
          }
        }
      ]
    }
  }
}

export const MultipleRelationFilterAdapter = (collection) => {
  collection = getCollection(collection);
  
  return (key, value) => {
    if (!value?.length){
      return {}
    }
    
    return {
      and: [
        {
          [key]: {
            in: value.map(collection.getId.bind(collection))
          }
        }
      ]
    }
  }
}

export const OrganisationFilterContextAdapter = (key, value) => {
  return {
    and: [
      {
        [key]: {
          equals: getOrganisationId()
        }
      }
    ]
  }
}

export const YearRangeFilterAdapter = (key, value) => {
  const fragment = {and: []}
  
  if (value.from && value.from.toString().length === 4) {
    fragment.and.push({[key]: {greater_than_equal: value.from}});
  }
  
  if (value.to && value.to.toString().length === 4) {
    fragment.and.push({[key]: {less_than_equal: value.to}});
  }
  
  return fragment;
}

export const ResolutionFilterAdapter = (key, value) => {
  if (value === 'year') {
    return {
      and: [
        {halfYear: {in: [1, null]}}
      ]
    }
  }
  
  if (value === 'halfYear') {
    return {
      and: [
        {halfYear: {exists: true}}
      ]
    }
  }
}

export const SingleRelationInputAdapter = (collection) => {
  collection = getCollection(collection);
  
  return (key, value) => {
    return value ? collection.getId(value) : null;
  }
}

export const MultipleRelationInputAdapter = (collection) => {
  collection = getCollection(collection);
  
  return (key, value) => {
    return value?.length ? value.map(collection.getId.bind(collection)) : null;
  }
}

export const ObjectivePickerInputAdapter = (collection) => {
  collection = getCollection(collection);
  
  return (key, value) => {
    return value?.length ? value.map(collection.getId.bind(collection)) : null;
  }
}

export const OrganisationFormContextAdapter = (key, value) => {
  return getOrganisationId();
}
